import { useMemo } from 'react';
import { useProductPricingApi } from 'app/common/hooks';
import { isEmpty } from 'lodash';
import {
  PRICE_UNAVAILABLE,
  determineProductOrVariantPricing
} from 'app/product/utils/PricingUtils';

function useDetermineActiveOptionPricing(product, activeOption) {
  const productArray = useMemo(() => (product ? [product] : []), [product]);
  const { priceInfoResponse, isLoaded } = useProductPricingApi(productArray);

  return useMemo(() => {
    let productPricing = {};
    let activeOptionPricing = {};

    const productId = product?.id;
    const priceData = productId ? priceInfoResponse?.[productId] : null;

    if (priceData) {
      const { priceInfo } = priceData;
      productPricing = determineProductOrVariantPricing(product, priceInfo);
      const activeOptionPriceInfo = activeOption?.priceInfo ?? priceInfo;
      activeOptionPricing = determineProductOrVariantPricing(
        activeOption,
        activeOptionPriceInfo
      );
    }

    const pricing =
      (activeOptionPricing && Object.keys(activeOptionPricing).length > 0
        ? activeOptionPricing
        : productPricing) || {};

    // empty until pricing has loaded, so a loading placeholder is shown
    // rather than "Call for Pricing"
    return isEmpty(pricing) && isLoaded ? PRICE_UNAVAILABLE : pricing;
  }, [product, activeOption, priceInfoResponse, isLoaded]);
}

export default useDetermineActiveOptionPricing;
